import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

/**
 * Simplified GroupChat Service
 * Uses the new streamlined groupchat APIs
 */

// Get user's groups
export const getUserGroups = async (userId, groupType = null) => {
  try {
    const params = groupType ? { groupType } : {};
    const response = await api1.get(API_ENDPOINTS.GET_USER_GROUPS(userId), {
      params,
      meta: { showToast: false },
    });
    // Return the data array from the response
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching user groups:", error);
    return [];
  }
};

// Create new group
export const createGroup = async (groupData) => {
  try {
    const response = await api1.post(
      API_ENDPOINTS.CREATE_GROUP,
      groupData,
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating group:", error);
    return null;
  }
};

// Join group
export const joinGroup = async (groupId, userId) => {
  try {
    const response = await api1.put(
      API_ENDPOINTS.JOIN_GROUP(groupId),
      { userId },
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error joining group:", error);
    return null;
  }
};

// Leave group
export const leaveGroup = async (groupId, userId) => {
  try {
    const response = await api1.put(
      API_ENDPOINTS.LEAVE_GROUP(groupId),
      { userId },
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error leaving group:", error);
    return null;
  }
};

// Send message to group
export const sendMessage = async (groupId, messageData) => {
  try {
    const response = await api1.post(
      API_ENDPOINTS.SEND_GROUP_MESSAGE(groupId),
      messageData,
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending message:", error);
    return null;
  }
};

// Get group messages
export const getGroupMessages = async (groupId, userId = null) => {
  try {
    const params = userId ? { userId } : {};
    const response = await api1.get(API_ENDPOINTS.GET_GROUP_MESSAGES(groupId), {
      params,
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching group messages:", error);
    return null;
  }
};

// Helper function to create group with participants
export const createGroupWithParticipants = async (name, description, type, participants, admin) => {
  const groupData = {
    name,
    description,
    type,
    participants,
    admin
  };
  
  return await createGroup(groupData);
};

// Helper function to send text message
export const sendTextMessage = async (groupId, sender, content) => {
  const messageData = {
    sender,
    content
  };
  
  return await sendMessage(groupId, messageData);
};

// Helper function to get user's groups by type
export const getUserGroupsByType = async (userId, groupType) => {
  return await getUserGroups(userId, groupType);
};

// Helper function to check if user is in group
export const isUserInGroup = async (groupId, userId) => {
  const response = await getGroupMessages(groupId, userId);
  return response && response.success;
};

// Get all groups separated by categories
export const getAllGroups = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_ALL_GROUPS, {
      meta: { showToast: false },
    });
    return response.data?.data || { learningGroups: [], industryGroups: [] };
  } catch (error) {
    console.error("Error fetching all groups:", error);
    return { learningGroups: [], industryGroups: [] };
  }
};

export default {
  getUserGroups,
  getAllGroups,
  createGroup,
  joinGroup,
  leaveGroup,
  sendMessage,
  getGroupMessages,
  createGroupWithParticipants,
  sendTextMessage,
  getUserGroupsByType,
  isUserInGroup
};
